
import CoreFormElementInputBase from './BaseInput';
import { CoreFormElementProps } from '../../interfaces/';
import { FORM_ELEMENT_PROPS, INPUT_TYPE_TIME } from '../../constants/';
import { HashMapMergeProps } from '../../../../../utils/';

/**
 * Time Input Element
 * @export
 * @class CoreFormElementTime
 * @extends {CoreFormElementInputBase}
 */
export default class CoreFormElementTime extends CoreFormElementInputBase {
  /**
   * Default Props
   * @static
   * @type {Omit<CoreFormElementProps, 'name'>}
   * @memberof CoreFormElementTime
   */
  public static defaultProps: Omit<CoreFormElementProps, 'name'> = HashMapMergeProps(FORM_ELEMENT_PROPS, {
    type: INPUT_TYPE_TIME,
    step: 1,
  });
}
